import styles from "./testCaseModalParameterInput.module.scss";
import { Popup } from "../../../shared/components/popup/popup";
import {
  FieldValues,
  Path,
  PathValue,
  useController,
  UseControllerProps
} from "react-hook-form";
import {
  useCallback,
  useEffect,
  useRef,
  useState
} from "react";
import { Control } from "react-hook-form/dist/types";
import {ParametersConstants, RequestParametersConstants} from "../../../constants/parameters.constants";

type TestCaseModalParameterInputProps<T extends FieldValues> = {
  control: Control<T>
  title: string;
  isResponseParameters?: boolean,
  error?: string;
} & UseControllerProps<T>

export const TestCaseModalParameterInput = <T extends FieldValues>({title, control, name, isResponseParameters, error}: TestCaseModalParameterInputProps<T>) => {

  const {
    field: { ref, onChange, value, ...inputProps },
  } = useController({
    name,
    control,
    defaultValue: "" as PathValue<T, Path<T>>
  });

  const [customInsert, setCustomInsert] = useState<{ startPos: number, textInsertLength: number }>();
  const [showPopup, setShowPopup] = useState(false);
  const inputContainer = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>();

  useEffect(() => {
    if (!!customInsert && inputRef.current) {
      inputRef.current.selectionStart = inputRef.current.selectionEnd = customInsert.startPos + customInsert.textInsertLength;
      inputRef.current.focus();
      setCustomInsert(undefined);
    }
  }, [value, customInsert, setCustomInsert]);

  const onBlur = useCallback(() => {
    setShowPopup(false);
  }, [setShowPopup]);

  const onFocus = useCallback(() => {
    setShowPopup(true);
  }, [setShowPopup]);

  const clickConstantParameterItem = (parameter: ParametersConstants | RequestParametersConstants) => {
    const input = inputRef.current;
    const textToInsert = `<<${parameter}>>`;
    addTextToInput(textToInsert, input);
  }

  const addTextToInput = useCallback((textToInsert: string, input?: HTMLInputElement) => {
    if (!!input) {
      const startPos = input.selectionStart || 0;
      const endPos = input.selectionEnd || 0;
      const beforeText = input.value.substring(0, startPos);
      const afterText = input.value.substring(endPos, input.value.length);
      onChange(beforeText + textToInsert + afterText);
      setCustomInsert({ startPos, textInsertLength: textToInsert.length });
    }
  }, []);


  return (
    <div className={styles.inputContainer}>
      <span title={title}>{title}</span>
      <div className={styles.input} ref={inputContainer}>
        <input maxLength={1000}
               autoComplete="off"
               {...inputProps}
          onBlur={() => {
            inputProps.onBlur();
            onBlur();
          }}
               onFocus={onFocus}
               onChange={onChange}
               value={value}
               ref={(e) => {
                 ref(e);
                 inputRef.current = e || undefined;
               }}
        />
        {error && <p className={styles.errorMessage}> {error}</p>}

        <Popup isShow={showPopup}
               classContainer={styles.popup}
               top={2}
               parent={inputContainer.current}
               child={
                 <div className={styles.popupContainer}
                      onMouseDown={(e) => e.preventDefault()}
                 >
                   {Object.values(isResponseParameters ? ParametersConstants : RequestParametersConstants).map((parameter) => (
                     <div key={parameter}
                          className={styles.item}
                          onClick={(e) => {
                            e.stopPropagation();
                            clickConstantParameterItem(parameter);
                          }}>
                       {parameter}
                     </div>
                   ))}
                 </div>
               }
        />
      </div>
    </div>
  )
}